import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const Randomize = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 20 20">
    <path d="M14.1667 2.5L18.5417 6.25L14.1667 10L18.5417 13.75L14.1667 17.5V15H11.8834L9.53341 12.65L11.3001 10.8833L12.9167 12.5H14.1667V10V7.5H12.9167L5.41675 15H1.66675V12.5H4.38341L11.8834 5H14.1667V2.5ZM1.66675 5H5.41675L7.76675 7.35L6.00008 9.11667L4.38341 7.5H1.66675V5Z" />
  </SvgIcon>
));

Randomize.displayName = 'Randomize';

export default Randomize;
